export default __webpack_public_path__ + "static/media/RestaurantLandingPage.e0dec44b.jpeg";